import type { ReactNode } from "react";

interface LightboxSidebarProps {
  title: string;
  children: ReactNode;
}

export function LightboxSidebar({ title, children }: LightboxSidebarProps) {
  return (
    <div
      className="w-full md:w-64 bg-card rounded-2xl md:rounded-3xl p-3 md:p-5 flex flex-col gap-2 md:gap-3 border border-border shadow-2xl order-2 md:order-1 md:max-h-[calc(100vh-120px)] md:overflow-y-auto"
    >
      <h3 className="text-xs md:text-base font-black text-foreground">
        {title}
      </h3>
      {children}
    </div>
  );
}
